'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var React = require('react');
var IconBase = require('@ali/vu-icon-base');

function Checkbox(props) {
  return React.createElement(
    IconBase,
    _extends({ viewBox: '0 0 1024 1024' }, props),
    React.createElement('path', { d: 'M896 64H128c-35.2 0-64 28.8-64 64v768c0 35.2 28.8 64 64 64h768c35.2 0 64-28.8 64-64V128c0-35.2-28.8-64-64-64z m0 800c0 19.2-12.8 32-32 32H160c-19.2 0-32-12.8-32-32V160c0-19.2 12.8-32 32-32h704c19.2 0 32 12.8 32 32v704z' }),
    React.createElement('path', { d: 'M694.4 364.8l-227.2 227.2-112-112c-12.8-12.8-32-12.8-44.8 0-12.8 12.8-12.8 32 0 44.8l134.4 134.4c6.4 6.4 12.8 9.6 22.4 9.6 9.6 0 16-3.2 22.4-9.6l249.6-249.6c12.8-12.8 12.8-32 0-44.8-12.8-9.6-32-9.6-44.8 0z' })
  );
}
Checkbox.displayName = 'Checkbox';

module.exports = Checkbox;


//////////////////
// WEBPACK FOOTER
// ./~/_@ali_ve-icons@4.1.6@@ali/ve-icons/build/svglib/checkbox.js
// module id = 159
// module chunks = 0